import { render, staticRenderFns } from "./ListByPlace.vue?vue&type=template&id=0ef8cc68&scoped=true&"
import script from "./ListByPlace.vue?vue&type=script&lang=js&"
export * from "./ListByPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef8cc68",
  null
  
)

export default component.exports